import {Activity, ActivityVariant, Id, JournalActivity, MyJournal} from "./types";
import {AppTL} from "./gen/tl";
import {CommonResult} from "./CommonResult";
// import {UiFlashContainer} from "mu-widget/lib/components/UiFlash";
import {sleepPromise} from "mu-js-utils/lib/utils";
import {PlanItemRepeatingUtil} from "./PlanItemRepeatingUtil";
import {DateTime} from "mu-js-utils/lib/DateTime";

export class DataStore {

    public tl: AppTL;

    protected cache: Record<string, any> = {};

    protected getCached<T>(key: string, callback: () => T): T {
        if (typeof this.cache[key] === "undefined") {
            this.cache[key] = callback();
        }

        return this.cache[key];
    }

    public async getActivities(): Promise<Activity[]> {
        return this.getCached('activities', () => this.tl.getNumbering('activity'));
    }

    public async getActivityVariants(actityId: number): Promise<ActivityVariant[]> {
        return (await this.getNumbering<ActivityVariant[]>('activityVariant'))
            .filter(av => av.activityId === actityId);
    }

    public getNumbering<T=any>(name: string): Promise<T>
    {
        return this.getCached('numbering_' + name, () => this.tl.getNumbering(name));
    }

    public async getCurrentUser() {
        return this.tl.getCurrentUser();
    }

    public async getMyPlans() {
        return this.tl.getMyPlans();
    }

    public async loginUser(email: string, password: string) {
        return this.tl.login(email, password);
    }

    public async registerUser(data: any) {
        return this.tl.register(data);
    }

    public async registerOrRecovery(email: string): Promise<CommonResult> {
        return this.tl.registerOrRecovery(email);
    }

    public static get(): DataStore
    {
        return new DataStore();
    }

    async saveActivity(id: Id | null, data: any): Promise<CommonResult> {
        if (data.value === '') data.value = 0;
        const res = this.tl.saveJournalActivity(id, data);

        return res;
    }

    public setPassword(tokenWithId: string, password: string) : Promise<CommonResult> {
        return this.tl.setPassword(tokenWithId, password);
    }

    public registerFinalize(tokenWithId: string, data: any) : Promise<CommonResult> {
        return this.tl.registerFinalize(tokenWithId, data);
    }

    async logout() {
        return this.tl.logout();
    }

    async findJournalActivities(day: string): Promise<any[]>
    {
        return (await this.tl.findJournalActivities(day))
            .map(item => ({
                ...item,
                dtStart: new Date(item.dtStart),
            }));
    }

    public async getMyJournal(day: string) : Promise<MyJournal> {
        const data = await this.tl.getMyJournal(day);
        return data;
    }

    public stopWatching(id: number) : Promise<CommonResult> {
        return this.tl.stopWatching(id);
    }

    public deleteJournalActivity(id: number): Promise<CommonResult> {
        return this.tl.deleteJournalActivity(id);
    }

    public startActivityWatch(activityId: number, activityVariantId: number | null): Promise<CommonResult> {
        return this.saveActivity(null, {
            activityId,
            activityVariantId,
            value: null,
            dtStart: new Date().toISOString(),
        });
    }

    public getJournalActivity(id: number) : Promise<JournalActivity>
    {
        return this.tl.getJournalActivity(id);
    }

    constructor() {
        this.tl = new AppTL();
        this.tl.onLoaded = async(handle, data) => {
            await sleepPromise(1);
            for (const message of data?.context?.flashMessages || []) {
                //todo: dostaň to tam jinak at to nenafukuje sw.js
                // UiFlashContainer.add(message.message, message.type);
            }
        }
    }

    public async getActivity(id: number): Promise<Activity|null> {
        return (await this.getActivities()).find(activity => activity.id === id) ?? null;
    }

    public async getActivityVariant(id: number): Promise<ActivityVariant|undefined> {
        return (await this.getNumbering<ActivityVariant[]>('activityVariant'))
            .find(activityVariant => activityVariant.id === id);
    }

    protected activePlans: number[] = [];
    async setMyActivePlans(ids: number[])
    {
        this.activePlans = ids;
        //todo save
    }

    async getMyPlansItemsForDay(day: string) {
        //todo: cache
        const planItems = await this.tl.getMyPlanItems(this.activePlans);
        return PlanItemRepeatingUtil.inDay(planItems, DateTime.dateFromInput(day)!);
    }
}

export const dataStore = DataStore.get();